const API_URL = process.env.REACT_APP_API_URL;

// Scrapper API
export const getScrapperData = async (filters) => {
  try {
    const response = await fetch(`${API_URL}/scrapper/scrapper/data`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(filters || {})
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP Error: ${response.status}`);
    }
    return await response.json();
  } catch (err) {
    console.error('API Error:', err);
    throw err;
  }
};

// Login API
export const loginEmployee = async ({ username, password }) => {
  try {
    const response = await fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    });
    if (!response.ok) {
      const error = await response.json();
      return { success: false, message: error.message };
    }
    const data = await response.json();
    return { success: true, data };
  } catch (err) {
    return { success: false, message: 'Network error' };
  }
};

// Forgot Password API
export const forgotPassword = async ({ email }) => {
  try {
    const response = await fetch(`${API_URL}/auth/forgot-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email })
    });
    if (!response.ok) {
      const error = await response.json();
      return { success: false, message: error.message };
    }
    const data = await response.json();
    return { success: true, data };
  } catch (err) {
    return { success: false, message: 'Network error' };
  }
};